export default __webpack_public_path__ + "static/media/banner-default.03bdb22f.png";